export const REMOVE_ACTIVE_ENHANCEMENT = 'REMOVE_ACTIVE_ENHANCEMENT'

export const removedEnhancement = activeEnhancement => ({
	type: REMOVE_ACTIVE_ENHANCEMENT,
	payload: activeEnhancement
})

export default function removeActiveEnhancement(updatedActiveEnhancements) {
	return dispatch => {
		dispatch(removedEnhancement(updatedActiveEnhancements))
	}
}



// WEBPACK FOOTER //
// ./src/actions/removeActiveEnhancementActions.js